import { gql } from '@apollo/client';
export const QUERY = gql `
  query documentRenderInputForEsigningAttachment($id: ID!, $companyId: UUID!) {
    fileSystemDocument: fileSystemDocument(id: $id) {
      id
      strippedHtmlBody
    }
    company: company2(id: $companyId) {
      id
      logoPath
      logoUploaded
    }
  }
`;
